/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, HostListener} from '@angular/core';
import {IfOpenService} from '../../utils/conditional/if-open.service';
export class TooltipTrigger {
/**
 * @param {?} ifOpenService
 */
constructor(private ifOpenService: IfOpenService) {}
/**
 * @return {?}
 */
showTooltip(): void {
        this.ifOpenService.open = true;
    }
/**
 * @return {?}
 */
hideTooltip(): void {
        this.ifOpenService.open = false;
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrTooltipTrigger]", host: {"[attr.tabindex]": "0"}}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: IfOpenService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'showTooltip': [{ type: HostListener, args: ["mouseenter", ] },{ type: HostListener, args: ["focus", ] },],
'hideTooltip': [{ type: HostListener, args: ["mouseleave", ] },{ type: HostListener, args: ["blur", ] },],
};
}

function TooltipTrigger_tsickle_Closure_declarations() {
/** @type {?} */
TooltipTrigger.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TooltipTrigger.ctorParameters;
/** @type {?} */
TooltipTrigger.propDecorators;
/** @type {?} */
TooltipTrigger.prototype.ifOpenService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
